import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import QuizPreviewAsync from './components/quizPrewiev/QuizPreviewAsync';
import styles from './overview.css';
import { requestClearStatisticPreview } from '../../../../../../../data/quiz/preview/api';
import Close from '../../../../../../../assets/svg/close.svg';

/**
 *
 * @type {React.NamedExoticComponent<{readonly quizType?: *}>}
 */
const Overview = React.memo(( ) => {

    const { quiz, global:{ quizType } } = useSelector( ( state ) => state );
    const  [frame, setFrame ] = useState(undefined);
    const [ questionList, setQuestionList ] = useState( [] );

    useEffect( () => {
        const { questions } = quiz;
        setQuestionList( [ ...questions ] );
    }, [] );

    const exitPreviewPage = () => {
        if ( Boolean( frame.contentWindow.document.getElementById( 'player-1' ) ) ) {
            const gameID = frame.contentWindow.document.getElementById( 'player-1' ).dataset.gameid;
            if ( gameID )
                requestClearStatisticPreview( Number( gameID ) );
        }
    };

    const previewGameIdPlayer = ( iframe ) => {
        setFrame(iframe);
    };

    return (
        <div className={ styles.wrapper }>
            <NavLink
                onClick={ exitPreviewPage }
                to={ `/${ quizType }/${ quiz && quiz.quiz_localization && quiz.quiz_localization.id }/editor/` }
                className={ styles.closeLink }> <Close/>
            </NavLink>
            <QuizPreviewAsync props={ {quizType: quizType,  previewGameIdPlayer: previewGameIdPlayer , questionList: questionList } }/>
        </div>
    );
});

export default Overview;